<template>
<div class="wrapper wrapper-content px-1 pt-1">
<!-- Controls -->
  <div v-if="noversion" class="mt-5">
    <!-- <h4>{{ $t("navigations.there are currently no study versions available for reviewplease check back later or create a new study version to begin") }}</h4> -->
    <main class="d-flex align-items-center justify-content-center">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-md-10 col-lg-8">
            <div class="card shadow-sm text-center p-4">
              <div class="d-flex justify-content-center mb-3">
              <!-- Simple SVG illustration -->
                <svg class="card-illustration" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                <rect x="6" y="10" width="52" height="40" rx="4" fill="#e9f5ff"/>
                <path d="M18 22h28M18 30h28M18 38h16" stroke="#3b82f6" stroke-width="2" stroke-linecap="round"/>
                <circle cx="48" cy="18" r="3" fill="#60a5fa"/>
                </svg>
              </div>
              <h6 class="card-title mb-2">{{ $t("navigations.there are currently no study versions available for comparison") }}</h6>
              <p class="text-muted mb-4">{{ $t("navigations.please check back later or create a new study version to begin") }}</p>
              <!-- <div class="d-flex justify-content-center gap-2">
                <a href="#" @click.prevent="goToCreateNewVersion()" class="btn btn-primary">{{ $t("navigations.add new study version") }}</a>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
  <div v-else class="ibox-content row px-3 py-0">
    <div class="col-md-6 d-flex justify-content-start align-items-center px-0">
      <div class="m-0">
        <a @click.prevent="showlegends = !showlegends" class="close-link" title="Show legends">
          <img src="../../assets/img/icons/information.png" alt="Orientation" style="width: 26px; height: 26px" />
        </a>
      </div>
    </div>

    <div class="col-md-6 d-flex justify-content-end align-items-center px-0">
      <div v-if="graphidentifier === 'soa'" class="me-3">
        <label class="mb-0 me-2">{{ $t('navigations.versions') }}</label>
          <select
            class="form-select form-select-sm d-inline-block w-auto"
            v-model="selectedVersion"
            @change="loadGraph"
            >
            <option v-for="ver in versionList" :key="ver" :value="ver">
                  {{ ver }}
            </option>
          </select>
      </div>

      <div class="m-2">
        <a @click="compareStudyVersions()" class="close-link" title="Reset Graph">
          <img src="../../assets/images/reset_graph.svg" alt="Orientation" style="width: 26px; height: 26px" />
        </a>
      </div>

      <div class="m-2">
        <a v-if="selectedorientation === 'LR'" @click="selectedorientation = 'TB'" class="close-link" title="Horizontal Layout">
          <img src="../../assets/images/orientation_Horizontal.svg" alt="Orientation" style="width: 26px; height: 26px" />
        </a>
          <a v-if="selectedorientation === 'TB'" @click="selectedorientation = 'LR'" class="close-link" title="Vertical Layout">
          <img src="../../assets/images/orientation_Vertical.svg" alt="Orientation" style="width: 26px; height: 26px" />
        </a>
      </div>

      <div class="m-2">
        <a @click="zoomout()" class="close-link" title="zoom out">
          <img src="../../assets/images/zoom_out_graph.svg" alt="Orientation" style="width: 26px; height: 26px" />
        </a>
      </div>

      <div class="m-2">
        <a @click="zoomin()" class="close-link" title="zoom in">
          <img src="../../assets/images/zoom_graph.svg" alt="Orientation" style="width: 26px; height: 26px" />
        </a>
        </div>
    </div>
  </div> 
  <div v-if="showlegends" class="ibox-content row px-3 py-0">
      <div v-if="!spinner" class="col-md-12 p-2">
        <!-- Make THIS a flex row -->
        <div class="legend-list d-flex flex-wrap align-items-center">
          <template v-for="(item, key) in legendStatus">
            <div
              v-if="typeArray.includes(key)"
              :key="key"
              @mouseover="showPopup(key, $event)"
              @mouseleave="hidePopup"
              class="legend-item d-inline-flex align-items-center border-right px-2"
            >
              <span class="mr-2">{{ key }}:</span>
              <img
                :src="require(`@/assets/images/GraphShapes/${getIconName(key)}.svg`)"
                alt="Shape"
                class="legandicon"
              />
            </div>
          </template>
        </div>

        <!-- Popup -->
        <div
          v-if="popup.show && difflegendStatus[popup.type]"
          class="status-popup"
          :style="{ left: popup.x + 'px', top: popup.y + 'px' }"
        >
          <div v-for="status in difflegendStatus[popup.type]" :key="status.label" class="status-item">
            <div class="color-circle" :style="{ backgroundColor: status.color }"></div>
            <span class="status-label">{{ status.label }}</span>
          </div>
        </div>
      </div>
  </div>
  <div v-if="!noversion" class="ibox-content row mb-1 px-0 py-2 diff-graph-stage">
      <!-- <div v-if="noversion">
      <h6>There is no versions to compare</h6>
      </div> -->
      <div v-if="!noversion" class="d-flex" :class="{ 'graphs-loading': isGraphsLoading }">
        <!-- IMPORTANT: different refs + keys + unique container-id props -->
        <!-- <div class="col-md-12 d-flex">
          <div class="col-md-5">Version</div>
          <div class="col-md-5">Version</div>
          <div class="col-md-2"></div>
        </div> -->

        <div class="col-md-6 totalborder mr-1">
  <div class="mt-1"><strong> Old Version:</strong>
     <select
        class="form-select form-select-sm d-inline-block w-auto ml-2"
        v-model="selectedVersionOld"
        @change="validateandloadGraph('old')"
      >
      <option v-for="ver in versionList" :key="ver" :value="ver">
        {{ ver }}
      </option>
      </select>
  </div>

        <graphdiff
          ref="graphRight"
          :key="'graph-right-' + selectedLayout + '-' + graphidentifier"
          :container-id="'cy-right'"
          :stabilize-initial-render="true"
          :selected-orientation="selectedorientation"
          :customlabels="customlabel"
          :selectedpatientid="selectedpatient"
          @showsitegraph="showsitegraph"
          @showsubjectgraph="showsubjectgraph"
          @changevisitstatusmodel="changevisitstatusmodel"
          @graph-ready="markGraphReady('right')"
          :collapsedtypes="collapsedtypes"
          :graphdata="graphdataOld"
          :selectedLayout="selectedLayout"
          :menuitems="menuitems"
          @showproperties="showproperties"
          @uncheduledvisit="openunscheduledvisitModal"
          @showformmodel="showformmodel"
          :donotcollapse="donotcollapse"
        />
        </div>
        <div class="col-md-6 totalborder mr-1">
           <div class="mt-1"><strong> New Version:</strong>
            <select
              class="form-select form-select-sm d-inline-block w-auto ml-2"
              v-model="selectedVersionNew"
              @change="validateandloadGraph('new')"
            >
              <option v-for="ver in versionList" :key="ver" :value="ver">
                {{ ver }}
              </option>
            </select>
           </div>
          <graph
          
          ref="graphLeft"
         
          :key="'graph-left-' + selectedLayout + '-' + graphidentifier"
          :container-id="'cy-left'"
          :stabilize-initial-render="true"
          :selected-orientation="selectedorientation"
          :customlabels="customlabel"
          :selectedpatientid="selectedpatient"
          @showsitegraph="showsitegraph"
          @showsubjectgraph="showsubjectgraph"
          @changevisitstatusmodel="changevisitstatusmodel"
          @graph-ready="markGraphReady('left')"
          :collapsedtypes="collapsedtypes"
          :graphdata="graphdataNew"
          :selectedLayout="selectedLayout"
          :menuitems="menuitems"
          @showproperties="showproperties"
          @uncheduledvisit="openunscheduledvisitModal"
          @showformmodel="showformmodel"
          :donotcollapse="donotcollapse"
        />
        </div>
      </div>

      <div v-if="isGraphsLoading && !noversion" class="graph-loading-overlay">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
  </div>

  <!-- Popup Details Modal -->
  <div v-if="detailspopup" class="modal-wrapper is-visible">
      <div class="modal-container">
        <div class="titleclass">
          <h4 class="px-3 mt-1">Details</h4>
          <div class="closebutton mt-1">
            <a style="color: white" class="close-link">
              <i class="fa fa-times" @click.prevent="closedetailsModal"></i>
            </a>
          </div>
        </div>
        <div class="modelbody p-0">
          <div class="mb-3 p-2">
            <div class="form-group">
              <div class="d-flex flex-column flex-lg-row">
                <div class="col-lg-12 my-2">
                  <table class="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>Key</th>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(value, key) in nodeproperties" :key="key">
                        <td>{{ dictionaryfordetails[key] ? dictionaryfordetails[key] : key }}</td>
                        <td>{{ value }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="d-flex justify-content-center my-3">
                <button class="save_btn py-1 px-4" @click="closedetailsModal">
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>
    <!-- new visit create -->
    <manageVisitModal
      v-if="showSiteModal"
      :visitId="currentvisitid"
      @closeModal="closeModal()"
      @createVisit="loadGraph()"
    />
    <showformmodel
      v-if="setshowFormModal"
      :formid="currentform"
      :currentformstatus="currentformstatus"
      @closeformModal="closeformModal()"
    />
    <ChangeSchedulestatus
      v-if="showChangeSchedule"
      :changeStatus="changeStatus"
      statusType="Visit"
      @closeModal="closeshowChangeSchedule()"
    />

    <!-- Popup unscheduled visit Modal -->
    <div v-if="unscheduledvisitpopup" class="modal-wrapper is-visible">
      <div class="modal-containermaxwidth">
        <div class="titleclass d-flex justify-content-between px-3 py-2">
          <h4 class="mb-0">Add Unscheduled Visit</h4>
          <div class="tooltip-wrapper pointer" @click.prevent="closeunscheduledvisitModal()" style="float: right; cursor: pointer;">
            <i class="fa fa-times close-button-popups"></i>
            <span class="custom-tooltip-popups">Close</span>
          </div>
        </div>
        <div class="modelbody overflow-hidden p-0">
          <!-- unscheduledvisit contents starts -->
          <div class="form-group row p-3 mb-0">
            <div class="col-lg-3 my-2">
              <label class="col-form-label">
                {{ $t('navigations.visit no') }}<sup><i class="fa fa-asterisk required"></i></sup>
              </label>
              <input v-model="popupdata.visitNo" type="text" maxlength="1000" class="form-control my-2 my-lg-0" />
              <span class="errormsg" v-if="popuperrors[0] === false">
                {{ $t('navigations.please enter visit no') }}
              </span>
            </div>

            <div class="col-lg-3 my-2">
              <label class="col-form-label">
                {{ $t('navigations.visit name') }}<sup><i class="fa fa-asterisk required"></i></sup>
              </label>
              <input v-model="popupdata.visitName" type="text" maxlength="1000" class="form-control my-2 my-lg-0" />
              <span class="errormsg" v-if="popuperrors[1] === false">
                {{ $t('navigations.please enter visit/form name') }}
              </span>
            </div>

            <div class="col-lg-3 my-2">
              <label class="col-form-label">
                {{ $t('navigations.visit type') }}<sup><i class="fa fa-asterisk required"></i></sup>
              </label>
              <select class="form-select" placeholder="Visit Type" v-model="popupdata.visitType" valueProp="VisitTypeName">
                <option value="" selected>{{ $t('navigations.select') }}</option>
                <option v-for="options in visitList" :key="options.typename">
                  {{ options.typename }}
                </option>
              </select>
              <span class="errormsg" v-if="popuperrors[3] === false">
                {{ $t('navigations.please select a visit type') }}
              </span>
            </div>

            <div class="col-lg-3 my-2">
              <label class="col-form-label">Relation Type</label>
              <select class="form-select" v-model="popupdata.relationType" valueProp="VisitTypeName">
                <option value="Concurrent">Concurrent</option>
                <option value="Before">Before</option>
                <option value="After">After</option>
              </select>
              <span class="errormsg" v-if="popuperrors[3] === false">
                {{ $t('navigations.please select a visit type') }}
              </span>
            </div>

            <div class="col-lg-4 my-2">
              <label class="col-form-label">{{ $t('navigations.investigator') }}</label>
              <select class="form-control" name="popupaccount" v-model="popupdata.investigator">
                <option value="" selected>{{ $t('navigations.select') }}</option>
                <option v-for="user in users" :key="user.userID" :value="user.email">
                  {{ user.name }}
                </option>
              </select>
            </div>

            <div class="col-lg-4 my-2">
              <label class="col-form-label">
                {{ $t('navigations.visit date') }}<sup><i class="fa fa-asterisk required"></i></sup>
              </label>
              <input v-model="popupdata.visitDate" type="date" max="9999-12-31" min="minDate" class="form-control my-2 my-lg-0" />
              <span class="errormsg" v-if="popuperrors[4] === false">
                {{ $t('navigations.please enter visit date') }}
              </span>
            </div>

            <div class="col-lg-4 my-2">
              <label class="col-form-label">
                {{ $t('navigations.form name') }}<sup><i class="fa fa-asterisk required"></i></sup>
              </label>
              <Multiselect
                v-model="selectedTemplateIds"
                mode="multiple"
                valueProp="templateId"
                placeholder="Select Form"
                label="templateName"
                :options="templatelist"
                :hideSelected="false"
                :closeOnSelect="false"
                class="multiselect-template-theme mr-0"
              >
                <template #option="{ option }">
                  {{ option.templateName }} ({{ option.version }}) - {{ option.languageCode.toUpperCase() }}
                </template>
              </Multiselect>
              <span class="errormsg" v-if="popuperrors[2] === false">
                {{ $t('navigations.please select a visit template') }}
              </span>
            </div>

            <div class="col-lg-12">
              <label class="col-form-label">{{ $t('navigations.reason') }}</label>
              <textarea v-model="popupdata.visitNote" class="form-control" rows="3"></textarea>
            </div>

            <div class="text-center">
              <span type="button" class="save_btn py-1 px-4 mt-3" @click.prevent="addUnscheduledVisit()">
                {{ $t('navigations.save') }}
              </span>
            </div>
          </div>
          <!-- unscheduledvisit contents ends -->
        </div>
      </div>
    </div>
</template>

<!-- keep your original logic -->
<script src="./soadiff.js"></script>

<style scoped>
@import "../../assets/css/style.css";

.popup-menu {
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 3px;
    padding: 5px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
  }
  
  .popup-menu ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .popup-menu li {
    padding: 3px 8px;
    cursor: pointer;
  }
  
  .popup-menu li:hover {
    background: #f0f0f0;
  }
  
  .modal-wrapper {
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 1;
    pointer-events: auto;
    overflow: hidden;
    z-index: 9999;
  }
  
  .modal-container {
    background: #fff;
    width: 80%;
    max-width: 600px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease-in-out;
  }
  .modal-containermaxwidth{
    background: #fff;
    width: 80%;
    max-width: 1000px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease-in-out;
  }
  .is-visible {
    opacity: 1;
    pointer-events: auto;
  }
  
  .table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
  }
  
  .table th,
  .table td {
    padding: 8px;
    border: 1px solid #ddd;
  }
  
  .table th {
    background-color: #f4f4f9;
    font-weight: bold;
  }
  
  .table-striped tbody tr:nth-child(odd) {
    background-color: #f9f9f9;
  }
  .totalborder{
    border: 1px solid #ddd;
  }
.spinnerborder{
  border: 1px solid #ddd;
  border-top: 0px;
}
.diff-graph-stage {
  position: relative;
}
.graphs-loading {
  visibility: hidden;
}
.graph-loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  z-index: 2;
}
.legandicon{
  width: 22px;
  height: 22px;
}
.status-popup {
  position: fixed; /* Changed from absolute to fixed */
  background: white;
  border: 1px solid #ddd;
  padding: 12px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  z-index: 1000;
  width: 160px; /* Fixed width */
  left: 0; /* Will be overridden by inline style */
  top: 0; /* Will be overridden by inline style */
}

.status-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 6px 0;
}

.color-circle {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}

.status-label {
  font-size: 0.85rem;
  color: #333;
}

.card-illustration {
        width: 120px;
        height: 120px;
      }


</style>
